// Fixed & simplified component from https://github.com/akiran/react-highlight/blob/master/src/optimized.js

import React from 'react';
import hljs from 'highlight.js/lib/core';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

export interface HighlightProps extends ClassNameProps {
    languages: string[];
}

export default class Highlight extends React.Component<HighlightProps> {
    static defaultProps = {
        innerHTML: false,
        className: '',
        languages: [],
    };
    private preRef = React.createRef<HTMLPreElement>();

    componentDidMount() {
        this.highlightCode();
    }

    componentDidUpdate() {
        this.highlightCode();
    }

    render() {
        const {children, className} = this.props;

        return (
            <pre ref={this.preRef}>
                <code className={className}>{children}</code>
            </pre>
        );
    }

    private highlightCode() {
        const {className, languages} = this.props;
        const nodes = this.preRef?.current?.querySelectorAll<HTMLElement>('pre code');

        if (!nodes) {
            return;
        }

        if (languages.length === 0 && className) {
            languages.push(className);
        }

        languages.forEach((lang) => {
            hljs.registerLanguage(lang, require(`highlight.js/lib/languages/${lang}`));
        });

        for (let i = 0; i < nodes.length; i++) {
            hljs.highlightBlock(nodes[i]);
        }
    }
}
